export const ROUNDED_FOCUS_RING = {
	outline: 'none',
	// brand-focus-ring, not focus-ring: the `focus.ring` token doesn't emit a --chakra-colors-focus-ring
	// var (resolves empty → invalid box-shadow → no ring). brand.focusRing is the same colour and exists.
	boxShadow: '0 0 0 2px var(--chakra-colors-brand-focus-ring)',
} as const;
